export interface UserBlock {
  id: string;
  logoUrl?: string;
  name: string;
  email: string;
  roleId?: string;
  scopeId?: string;
  isPendingInvite?: boolean;
}
